import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { formatNumber } from 'src/utils/format';

import { SUBSCRIPTION_PLAN, SUBSCRIPTION_TIER } from './const';

const TIER_PROPS = {
  /* "tiered" plan tiers */
  [SUBSCRIPTION_TIER.tier_migrate]: {
    price: 0,
    wordsLimit: 6 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_0]: {
    price: 0,
    wordsLimit: 5 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_19]: {
    price: 19,
    wordsLimit: 15 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_39]: {
    price: 39,
    wordsLimit: 35 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_99]: {
    price: 99,
    wordsLimit: 100 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_149]: {
    price: 149,
    wordsLimit: 165 * 1000,
  },
  [SUBSCRIPTION_TIER.tier_199]: {
    price: 199,
    wordsLimit: 240 * 1000,
  },

  /* "pro" plans tiers */
  [SUBSCRIPTION_TIER.pro_beta_ecommerce_tier_1]: {
    price: 399,
    priceAnnuallyPerMonth: 266,
    priceAnnually: 3192,
  },
  [SUBSCRIPTION_TIER.pro_beta_ecommerce_tier_2]: {
    price: 750,
    priceAnnuallyPerMonth: 500,
    priceAnnually: 6000,
  },
  [SUBSCRIPTION_TIER.pro_beta_publisher_tier_1]: {
    price: 499,
    priceAnnuallyPerMonth: 333,
    priceAnnually: 3992,
  },
  [SUBSCRIPTION_TIER.pro_beta_publisher_tier_2]: {
    price: 750,
    priceAnnuallyPerMonth: 500,
    priceAnnually: 6000,
  },

  [SUBSCRIPTION_TIER.seats_3]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 499,
      priceAnnuallyPerMonth: 4188 / 12,
      priceAnnually: 4188,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 3,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 99,
      priceAnnuallyPerMonth: 948 / 12,
      priceAnnually: 948,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 3,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 499,
      priceAnnuallyPerMonth: 4188 / 12,
      priceAnnually: 4188,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 3,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 99,
      priceAnnuallyPerMonth: 948 / 12,
      priceAnnually: 948,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 3,
    },
  },

  [SUBSCRIPTION_TIER.seats_4]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 558,
      priceAnnuallyPerMonth: 4776 / 12,
      priceAnnually: 4776,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 4,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 158,
      priceAnnuallyPerMonth: 1536 / 12,
      priceAnnually: 1536,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 4,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 558,
      priceAnnuallyPerMonth: 4776 / 12,
      priceAnnually: 4776,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 4,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 158,
      priceAnnuallyPerMonth: 1536 / 12,
      priceAnnually: 1536,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 4,
    },
  },

  [SUBSCRIPTION_TIER.seats_5]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 617,
      priceAnnuallyPerMonth: 5364 / 12,
      priceAnnually: 5364,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 5,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 217,
      priceAnnuallyPerMonth: 2124 / 12,
      priceAnnually: 2124,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 5,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 617,
      priceAnnuallyPerMonth: 5364 / 12,
      priceAnnually: 5364,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 5,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 217,
      priceAnnuallyPerMonth: 2124 / 12,
      priceAnnually: 2124,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 5,
    },
  },

  [SUBSCRIPTION_TIER.seats_6]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 676,
      priceAnnuallyPerMonth: 5952 / 12,
      priceAnnually: 5952,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 6,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 276,
      priceAnnuallyPerMonth: 2712 / 12,
      priceAnnually: 2712,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 6,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 676,
      priceAnnuallyPerMonth: 5952 / 12,
      priceAnnually: 5952,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 6,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 276,
      priceAnnuallyPerMonth: 2712 / 12,
      priceAnnually: 2712,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 6,
    },
  },

  [SUBSCRIPTION_TIER.seats_7]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 735,
      priceAnnuallyPerMonth: 6540 / 12,
      priceAnnually: 6540,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 7,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 335,
      priceAnnuallyPerMonth: 3300 / 12,
      priceAnnually: 3300,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 7,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 735,
      priceAnnuallyPerMonth: 6540 / 12,
      priceAnnually: 6540,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 7,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 335,
      priceAnnuallyPerMonth: 3300 / 12,
      priceAnnually: 3300,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 7,
    },
  },

  [SUBSCRIPTION_TIER.seats_8]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 794,
      priceAnnuallyPerMonth: 7128 / 12,
      priceAnnually: 7128,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 8,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 394,
      priceAnnuallyPerMonth: 3888 / 12,
      priceAnnually: 3888,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 8,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 794,
      priceAnnuallyPerMonth: 7128 / 12,
      priceAnnually: 7128,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 8,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 394,
      priceAnnuallyPerMonth: 3888 / 12,
      priceAnnually: 3888,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 8,
    },
  },

  [SUBSCRIPTION_TIER.seats_9]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 853,
      priceAnnuallyPerMonth: 7716 / 12,
      priceAnnually: 7716,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 9,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 453,
      priceAnnuallyPerMonth: 4476 / 12,
      priceAnnually: 4476,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 9,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 853,
      priceAnnuallyPerMonth: 7716 / 12,
      priceAnnually: 7716,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 9,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 453,
      priceAnnuallyPerMonth: 4476 / 12,
      priceAnnually: 4476,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 9,
    },
  },

  [SUBSCRIPTION_TIER.seats_10]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 912,
      priceAnnuallyPerMonth: 8304 / 12,
      priceAnnually: 8304,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 10,
    },
    [SUBSCRIPTION_PLAN.dataDriven]: {
      price: 512,
      priceAnnuallyPerMonth: 5064 / 12,
      priceAnnually: 5064,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.dataDriven,
      seats: 10,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 912,
      priceAnnuallyPerMonth: 8304 / 12,
      priceAnnually: 8304,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 10,
    },
    [SUBSCRIPTION_PLAN.ddTeamsLegacy]: {
      price: 512,
      priceAnnuallyPerMonth: 5064 / 12,
      priceAnnually: 5064,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 20,
      plan: SUBSCRIPTION_PLAN.ddTeamsLegacy,
      seats: 10,
    },
  },

  [SUBSCRIPTION_TIER.seats_11]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 971,
      priceAnnuallyPerMonth: 8892 / 12,
      priceAnnually: 8892,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 11,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 971,
      priceAnnuallyPerMonth: 8892 / 12,
      priceAnnually: 8892,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 11,
    },
  },

  [SUBSCRIPTION_TIER.seats_12]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1030,
      priceAnnuallyPerMonth: 9480 / 12,
      priceAnnually: 9480,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 12,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1030,
      priceAnnuallyPerMonth: 9480 / 12,
      priceAnnually: 9480,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 12,
    },
  },

  [SUBSCRIPTION_TIER.seats_13]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1089,
      priceAnnuallyPerMonth: 10068 / 12,
      priceAnnually: 10068,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 13,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1089,
      priceAnnuallyPerMonth: 10068 / 12,
      priceAnnually: 10068,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 13,
    },
  },

  [SUBSCRIPTION_TIER.seats_14]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1148,
      priceAnnuallyPerMonth: 10656 / 12,
      priceAnnually: 10656,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 14,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1148,
      priceAnnuallyPerMonth: 10656 / 12,
      priceAnnually: 10656,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 14,
    },
  },

  [SUBSCRIPTION_TIER.seats_15]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1207,
      priceAnnuallyPerMonth: 11244 / 12,
      priceAnnually: 11244,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 15,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1207,
      priceAnnuallyPerMonth: 11244 / 12,
      priceAnnually: 11244,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 15,
    },
  },

  [SUBSCRIPTION_TIER.seats_16]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1266,
      priceAnnuallyPerMonth: 11832 / 12,
      priceAnnually: 11832,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 16,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1266,
      priceAnnuallyPerMonth: 11832 / 12,
      priceAnnually: 11832,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 16,
    },
  },

  [SUBSCRIPTION_TIER.seats_17]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1325,
      priceAnnuallyPerMonth: 12420 / 12,
      priceAnnually: 12420,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 17,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1325,
      priceAnnuallyPerMonth: 12420 / 12,
      priceAnnually: 12420,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 17,
    },
  },

  [SUBSCRIPTION_TIER.seats_18]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1384,
      priceAnnuallyPerMonth: 13008 / 12,
      priceAnnually: 13008,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 18,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1384,
      priceAnnuallyPerMonth: 13008 / 12,
      priceAnnually: 13008,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 18,
    },
  },

  [SUBSCRIPTION_TIER.seats_19]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1443,
      priceAnnuallyPerMonth: 13596 / 12,
      priceAnnually: 13596,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 19,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1443,
      priceAnnuallyPerMonth: 13596 / 12,
      priceAnnually: 13596,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 19,
    },
  },

  [SUBSCRIPTION_TIER.seats_20]: {
    byPlan: true,
    [SUBSCRIPTION_PLAN.business]: {
      price: 1502,
      priceAnnuallyPerMonth: 14184 / 12,
      priceAnnually: 14184,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.business,
      seats: 20,
    },
    [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: {
      price: 1502,
      priceAnnuallyPerMonth: 14184 / 12,
      priceAnnually: 14184,
      wordsLimit: 'Unlimited',
      percentOfAnnualDiscount: 30,
      plan: SUBSCRIPTION_PLAN.businessSelfServeLegacy,
      seats: 20,
    },
  },
};

const BASE_WORKSPACE_COUNT = {
  [SUBSCRIPTION_PLAN.dataDriven]: 5,
  [SUBSCRIPTION_PLAN.business]: 10,
  [SUBSCRIPTION_PLAN.ddTeamsLegacy]: 5,
  [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: 10,
};

const SEAT_TIER_HIERARCHY = [
  SUBSCRIPTION_TIER.seats_3,
  SUBSCRIPTION_TIER.seats_4,
  SUBSCRIPTION_TIER.seats_5,
  SUBSCRIPTION_TIER.seats_6,
  SUBSCRIPTION_TIER.seats_7,
  SUBSCRIPTION_TIER.seats_8,
  SUBSCRIPTION_TIER.seats_9,
  SUBSCRIPTION_TIER.seats_10,
  SUBSCRIPTION_TIER.seats_11,
  SUBSCRIPTION_TIER.seats_12,
  SUBSCRIPTION_TIER.seats_13,
  SUBSCRIPTION_TIER.seats_14,
  SUBSCRIPTION_TIER.seats_15,
  SUBSCRIPTION_TIER.seats_16,
  SUBSCRIPTION_TIER.seats_17,
  SUBSCRIPTION_TIER.seats_18,
  SUBSCRIPTION_TIER.seats_19,
  SUBSCRIPTION_TIER.seats_20,
];

export const MAX_SEAT_TIER = {
  [SUBSCRIPTION_PLAN.dataDriven]: SUBSCRIPTION_TIER.seats_10,
  [SUBSCRIPTION_PLAN.business]: SUBSCRIPTION_TIER.seats_20,
  [SUBSCRIPTION_PLAN.ddTeamsLegacy]: SUBSCRIPTION_TIER.seats_10,
  [SUBSCRIPTION_PLAN.businessSelfServeLegacy]: SUBSCRIPTION_TIER.seats_20,
};
export const MIN_SEAT_TIER = SUBSCRIPTION_TIER.seats_3;

/**
 * Get next seat tier
 * @param {SUBSCRIPTION_TIER} tier - current tier
 * @param {SUBSCRIPTION_PLAN} plan - current plan
 * @returns {SUBSCRIPTION_TIER} - next tier
 */
export const getNextSeatTier = (tier, plan) => {
  const tierIndex = SEAT_TIER_HIERARCHY.indexOf(tier);
  if (tierIndex !== -1 && tier !== MAX_SEAT_TIER[plan]) {
    return SEAT_TIER_HIERARCHY[tierIndex + 1];
  }
};

/**
 * Get plan and tier that are suggested to upgrade to when the limit is hit
 * @param {SUBSCRIPTION_PLAN} plan - current plan
 * @param {SUBSCRIPTION_TIER} tier - current tier
 * @param {FEATURE_LIMITS} feature - feature that hit the limit
 * @returns {{plan: SUBSCRIPTION_PLAN, [tier]: SUBSCRIPTION_TIER}} - suggested plan and tier
 */
export const getPlanAndTierForNextLimit = (plan, tier = null, feature) => {
  const isMembersLimit = feature === FEATURE_LIMITS.membersPerCustomer;
  const isWorkspaceLimit = feature === FEATURE_LIMITS.workspacesPerCustomer;
  const isLiveScoringLimit = feature === FEATURE_LIMITS.liveScoring;
  const isPerformancePredictionsLimit = feature === FEATURE_LIMITS.performancePredictions;

  switch (plan) {
    case SUBSCRIPTION_PLAN.basic: {
      if (isMembersLimit) {
        return { plan: SUBSCRIPTION_PLAN.dataDriven, tier: MIN_SEAT_TIER };
      }
      return { plan: SUBSCRIPTION_PLAN.starter };
    }

    case SUBSCRIPTION_PLAN.starter:
    case SUBSCRIPTION_PLAN.starterLegacy: {
      if (
        isMembersLimit ||
        isWorkspaceLimit ||
        isLiveScoringLimit ||
        isPerformancePredictionsLimit
      ) {
        return { plan: SUBSCRIPTION_PLAN.dataDriven, tier: MIN_SEAT_TIER };
      }
      return { plan: SUBSCRIPTION_PLAN.business, tier: MIN_SEAT_TIER };
    }

    case SUBSCRIPTION_PLAN.dataDriven:
    case SUBSCRIPTION_PLAN.ddTeamsLegacy: {
      if (tier === MAX_SEAT_TIER[plan]) {
        // in max tier for the plan
        if (isWorkspaceLimit) {
          // workspace limit hit
          return { plan: SUBSCRIPTION_PLAN.business, tier };
        }
      }
      if (!isWorkspaceLimit) {
        // brand voice limit hit
        return { plan: SUBSCRIPTION_PLAN.business, tier };
      }
      // next tier
      return { plan: SUBSCRIPTION_PLAN.dataDriven, tier: getNextSeatTier(tier) };
    }

    case SUBSCRIPTION_PLAN.business:
    case SUBSCRIPTION_PLAN.businessSelfServeLegacy: {
      if (tier === MAX_SEAT_TIER[plan]) {
        // member or workspace limits hit
        return { plan: SUBSCRIPTION_PLAN.business };
      }
      if (!isWorkspaceLimit) {
        // brand voice limit hit
        return { plan: SUBSCRIPTION_PLAN.business };
      }
      // next tier
      return { plan: SUBSCRIPTION_PLAN.business, tier: getNextSeatTier(tier) };
    }

    default:
      return { plan: SUBSCRIPTION_PLAN.dataDriven, tier: MIN_SEAT_TIER };
  }
};

export const getWorkspacesByTier = (plan, tier) => {
  if (
    TIER_PROPS[tier] &&
    TIER_PROPS[tier][plan] &&
    TIER_PROPS[tier][plan].seats &&
    BASE_WORKSPACE_COUNT[plan]
  ) {
    return (
      BASE_WORKSPACE_COUNT[plan] +
      TIER_PROPS[tier][plan].seats -
      TIER_PROPS[MIN_SEAT_TIER][plan].seats
    );
  }
  return 1;
};

export const getSeatsByTier = (plan, tier = SUBSCRIPTION_TIER.seats_3) => {
  return TIER_PROPS?.[tier]?.[plan]?.seats || 3;
};

export const lessOrEqualSeatTier = (tierOne, tierTwo) => {
  const tierIndexOne = SEAT_TIER_HIERARCHY.indexOf(tierOne);
  const tierIndexTwo = SEAT_TIER_HIERARCHY.indexOf(tierTwo);
  if (tierIndexOne !== -1 && tierIndexTwo !== -1) {
    return tierIndexOne <= tierIndexTwo;
  }
};

export const getTierProperty = (tier, property, defaultValue = undefined, plan = undefined) => {
  let props = TIER_PROPS[tier];
  if (props && props.byPlan) {
    if (!plan || !props[plan]) {
      return defaultValue;
    }
    props = props[plan];
  }
  return (props && props[property]) || defaultValue;
};

export const getSubscriptionTierPrice = (tier, plan) => getTierProperty(tier, 'price', 0, plan);

export const getSubscriptionTierWordsLimit = (tier) => getTierProperty(tier, 'wordsLimit', 0);

export const getSubscriptionTierWordsLimitFormatted = (tier) => {
  const subscriptionLimit = getSubscriptionTierWordsLimit(tier);

  return Number.isFinite(subscriptionLimit) ? formatNumber(subscriptionLimit) : subscriptionLimit;
};

export const getPlanByTier = (tier, defaultPlan, plan) => {
  return getTierProperty(tier, 'plan', defaultPlan, plan);
};

export const getSubscriptionTierSeatsLimit = (tier, plan) =>
  getTierProperty(tier, 'seats', 1, plan);

export const getSubscriptionTierTextFormatObject = (tier) => {
  if (!tier) return null;

  const wordsLimit = getSubscriptionTierWordsLimitFormatted(tier);
  const seatsLimit = getSubscriptionTierSeatsLimit(tier);

  return { wordsLimit, seatsLimit };
};
